import React from 'react';
import { Link } from 'react-router';

import { connect } from 'react-redux';

class Footer extends React.Component {
  render() {
    return (
      <footer className="general-footer">
        <div className="container">
          <small>
            <i>© 2019 Centraide</i>
            <i className="separator">|</i>
            <Link to={'/faq'}>Foire aux questions</Link>
          </small>
          <small>
            Réalisé par
            <a
              href={'https://www.04h11.com/'}
              rel="noopener noreferrer"
              target={'_blank'}
            >
              04h11
            </a>
          </small>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
